import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";

const NAV_LINKS = ["Home","About","Skills","Experience","Projects","Services","Resume","Contact"];

export default function Navbar({ active }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 w-full z-50">
      {/* ── Desktop: centered floating pill ── */}
      <div className="hidden md:flex justify-center pt-4 px-4">
        <div className="bg-navy-900/80 backdrop-blur-md border border-navy-700/60
                        rounded-full px-3 py-2 flex items-center gap-1 shadow-glow">
          {/* Logo pill */}
          <button
            onClick={() => scrollTo("home")}
            className="text-cyan-400 font-extrabold text-base tracking-tight
                       hover:text-cyan-300 transition-colors px-4 py-1.5 mr-1">
            {"<NR />"}
          </button>

          <div className="w-px h-5 bg-navy-700 mx-1" />

          {/* Nav links */}
          {NAV_LINKS.map((link) => {
            const isActive = active === link.toLowerCase();
            return (
              <button
                key={link}
                onClick={() => scrollTo(link)}
                className={`relative px-4 py-2 rounded-full text-sm font-semibold
                            transition-all duration-200 ${
                  isActive
                    ? "bg-cyan-500 text-navy-950 shadow-glow"
                    : "text-slate-400 hover:text-cyan-400 hover:bg-navy-800"
                }`}>
                {link}
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Mobile: top bar ── */}
      <div className="md:hidden bg-navy-950/90 backdrop-blur-md border-b border-navy-800
                      px-4 h-14 flex items-center justify-between">
        <button onClick={() => scrollTo("home")}
          className="text-cyan-400 font-extrabold text-lg tracking-tight">
          {"<NR />"}
        </button>
        <button onClick={() => setMenuOpen(!menuOpen)} className="text-slate-300">
          {menuOpen ? <HiX size={22} /> : <HiMenu size={22} />}
        </button>
      </div>

      {/* ── Mobile dropdown ── */}
      {menuOpen && (
        <div className="md:hidden bg-navy-900 border-t border-navy-800 px-4 pb-4 pt-2">
          {NAV_LINKS.map((link) => (
            <button key={link} onClick={() => scrollTo(link)}
              className={`block w-full text-left py-2.5 text-sm font-medium
                          border-b border-navy-800 last:border-0 transition-colors ${
                active === link.toLowerCase()
                  ? "text-cyan-400"
                  : "text-slate-400 hover:text-cyan-400"
              }`}>
              {link}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}